export default __webpack_public_path__ + "static/media/txt.10b0f854.svg";